module.exports = __webpack_public_path__ + "images/柏纳s长图_09.jpg?v=9fdeef58";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_09.jpg
 ** module id = 172
 ** module chunks = 1 2
 **/